import { LANG_NAMES, LANGS, useSurveyI18n } from '../i18n';

/** "EN | FR" in the header; each button is named in its own language for screen readers. */
export function LangToggle() {
  const { lang, t, setLang } = useSurveyI18n();
  return (
    <div className="su-lang" role="group" aria-label={t.language}>
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          aria-label={LANG_NAMES[l]}
          aria-pressed={lang === l}
          className={lang === l ? 'active' : ''}
          onClick={() => setLang(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
